// Mock data for Manch Studios landing page

export const consultants = [
  {
    id: 1,
    name: "Nangil Rodrigues",
    role: "UX/UI Designer, Designer de modelos 3d",
    linkedin: "https://www.linkedin.com/in/nangil/",
    image: "https://customer-assets.emergentagent.com/job_b643e2b7-1d18-42a1-b855-27b1c43cee32/artifacts/8bocb07g_image.png"
  },
  {
    id: 2,
    name: "Priscila Loschi",
    role: "Responsável por CMF (color, material & finish design)",
    linkedin: "https://www.linkedin.com/in/priscilaloschi/",
    image: "https://customer-assets.emergentagent.com/job_b643e2b7-1d18-42a1-b855-27b1c43cee32/artifacts/hqg2qzn2_image.png"
  }
];

export const services = {
  digital: [
    {
      title: "UX Research",
      description: "Pesquisa de usuários para entender comportamentos e necessidades reais"
    },
    {
      title: "Design de Interfaces",
      description: "Criação de UI intuitiva e acessível para apps e websites"
    },
    {
      title: "Prototipagem Digital",
      description: "Desenvolvimento de protótipos interativos para validação"
    },
    {
      title: "Testes de Usabilidade",
      description: "Validação com usuários reais para otimizar a experiência"
    },
    {
      title: "Design Systems",
      description: "Criação de sistemas de design escaláveis e consistentes"
    }
  ],
  industrial: [
    {
      title: "Desenvolvimento de Conceito",
      description: "Criação de conceitos inovadores baseados em necessidades do mercado"
    },
    {
      title: "Modelagem 3D",
      description: "Desenvolvimento de modelos tridimensionais detalhados e precisos"
    },
    {
      title: "CMF Design",
      description: "Especificação de cores, materiais e acabamentos (Color, Material & Finish)"
    },
    {
      title: "Prototipagem Física",
      description: "Criação de protótipos funcionais para validação técnica"
    },
    {
      title: "Acompanhamento de Produção",
      description: "Suporte presencial durante processos de fabricação"
    }
  ],
  general: [
    {
      title: "Experiências Virtuais",
      description: "Desenvolvimento de aplicações para óculos VR"
    },
    {
      title: "UX Design",
      description: "Experiência do usuário completa e estratégica"
    },
    {
      title: "Design de Produtos Industriais",
      description: "Criação e desenvolvimento de produtos físicos"
    },
    {
      title: "Prototipagem e Teste",
      description: "Validação física e digital de conceitos"
    },
    {
      title: "Consultoria e Inovação",
      description: "Estratégias de inovação e transformação digital"
    },
    {
      title: "Treinamentos e Workshops",
      description: "Capacitação em metodologias de design"
    }
  ]
};

export const portfolio = [
  {
    id: 1,
    title: "Embalagem Água Mineral Alma",
    category: "Design de Produto",
    description: "Desenvolvimento de embalagem Tetrapak para água mineral destinada ao Hospital Sírio-Libanês. O projeto envolveu a criação de uma identidade visual sofisticada e funcional, considerando as necessidades específicas do ambiente hospitalar.",
    image: "https://customer-assets.emergentagent.com/job_b643e2b7-1d18-42a1-b855-27b1c43cee32/artifacts/v0cpip6p_aguaAlma.png",
    tags: ["Packaging", "Identidade Visual", "CMF Design"]
  },
  {
    id: 2,
    title: "Realidade Virtual",
    category: "Experiência Virtual",
    description: "Desenvolvimento de imagens fotorrealistas para visualização arquitetônica e design de produtos. Utilizando tecnologia de realidade virtual e renderização avançada, criamos representações visuais precisas.",
    image: "https://customer-assets.emergentagent.com/job_b643e2b7-1d18-42a1-b855-27b1c43cee32/artifacts/u0z97nwx_realidade.png",
    tags: ["VR", "3D Rendering", "Visualização"]
  },
  {
    id: 3,
    title: "Identidade Visual Chacon",
    category: "Identidade Visual",
    description: "Desenvolvemos identidades visuais marcantes através de um processo estratégico de pesquisa e análise do público-alvo. Construímos sistemas visuais completos que fortalecem a conexão emocional entre marca e consumidor.",
    image: "https://customer-assets.emergentagent.com/job_b643e2b7-1d18-42a1-b855-27b1c43cee32/artifacts/2ictptna_identidade.png",
    tags: ["Branding", "Identidade Visual", "Estratégia"]
  },
  {
    id: 4,
    title: "Escultura Digital",
    category: "Arte Digital",
    description: "Criamos esculturas digitais de alta qualidade para diversos segmentos e aplicações. Utilizando tecnologias avançadas de modelagem 3D e renderização, desenvolvemos representações artísticas e comerciais.",
    image: "https://customer-assets.emergentagent.com/job_b643e2b7-1d18-42a1-b855-27b1c43cee32/artifacts/2ofrc9f7_escultura.jpeg",
    tags: ["3D Modeling", "Arte Digital", "Renderização"]
  },
  {
    id: 5,
    title: "Experiência do Usuário - Pacientes Estrangeiros",
    category: "UX Research",
    description: "Realizamos estudos de caso aprofundados para identificar pontos de melhoria em processos e experiências do usuário. Desenvolvemos uma plataforma digital que simplifica e otimiza processos complexos.",
    image: "https://customer-assets.emergentagent.com/job_b643e2b7-1d18-42a1-b855-27b1c43cee32/artifacts/dwokvhu6_experie%CC%82ncia.png",
    tags: ["UX Research", "Service Design", "Healthcare"]
  },
  {
    id: 6,
    title: "Design de Interfaces",
    category: "UI/UX Design",
    description: "Criamos interfaces intuitivas e funcionais para sistemas de software e websites, sempre com foco na experiência do usuário e nas melhores práticas de UI/UX Design. Desenvolvemos desde dashboards complexos até interfaces clean.",
    image: "https://customer-assets.emergentagent.com/job_b643e2b7-1d18-42a1-b855-27b1c43cee32/artifacts/iw5eu1kh_interfaces.png",
    tags: ["UI Design", "UX Design", "Prototipagem"]
  },
  {
    id: 7,
    title: "Redesign Portal Hospital Sírio-Libanês",
    category: "UX/UI Design",
    description: "Projeto de redesign completo do portal do Hospital Sírio-Libanês, focado em melhorar a experiência do usuário e otimizar os processos de agendamento e acesso a informações.",
    videoUrl: "https://youtu.be/aPPThgDZljA?si=GQ6ugYmjcQAtzjJ5",
    image: "https://customer-assets.emergentagent.com/job_b643e2b7-1d18-42a1-b855-27b1c43cee32/artifacts/s1dptjy6_portal.png",
    tags: ["Healthcare", "UX Research", "Portal Design"]
  },
  {
    id: 8,
    title: "Car Customization - Vision DEA",
    category: "Experiência Interativa",
    description: "Aplicação interativa desenvolvida em Unreal Engine para a empresa Vision DEA. O projeto permite aos usuários personalizar completamente um carro em tempo real, incluindo troca de rodas, cores da pintura e materiais internos.",
    videoUrl: "https://youtu.be/opuIkiM9JkI?si=5uYuEj_b2HZRo6za",
    image: "https://customer-assets.emergentagent.com/job_b643e2b7-1d18-42a1-b855-27b1c43cee32/artifacts/xr0yiyj2_car.png",
    tags: ["Unreal Engine", "Interactive", "Automotive"]
  }
];

export const contactInfo = {
  phone: "+55 31 99434-1699",
  email: "contato@manchstudios.com",
  address: "Atendimento online completo e personalizado em todo o Brasil"
};

export const companyInfo = {
  name: "Manch Studios",
  tagline: "Consultoria em Design para Produtos Digitais e Industriais",
  description: "Na Manch Studios, acreditamos que o design é a ponte entre a inovação e as pessoas. Somos uma consultoria especializada em design de produtos digitais e industriais que transforma ideias em produtos que elevam e funcionam.",
  fullDescription: "Nossa equipe multidisciplinar utiliza metodologias comprovadas como Design Thinking, Human-Centered Design e UX Research para criar soluções inovadoras e eficazes para empresas de todos os portes em todo o Brasil. Trabalhamos de forma híbrida, oferecendo atendimento online completo e personalizado, com possibilidade de acompanhamento presencial quando necessário para desenvolvimentos específicos."
};